// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3enfK","notes":"Notes_notes__Dc4O7"};